import React from "react";
import { ArrowUpRight } from "lucide-react";
import { MAIN_APP_URL, trackCta } from "../../data/content";

const CtaButton = ({
  ctaId,
  label,
  location,
  variant = "primary",
  children,
  className = "",
  showArrow = true,
  ...props
}) => {
  const base =
    "group inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold tracking-tight transition-all duration-300 rounded-none";
  const styles =
    variant === "primary"
      ? "bg-white text-black hover:bg-cyan-300"
      : "bg-transparent text-white border border-white/20 hover:bg-white/5 hover:border-white/40";

  return (
    <a
      href={MAIN_APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={ctaId}
      onClick={() => trackCta(ctaId, label, location)}
      className={`${base} ${styles} ${className}`}
      {...props}
    >
      {children}
      {showArrow && (
        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      )}
    </a>
  );
};

export default CtaButton;
